import classNames from 'classnames';

import { IconNameV1, IconV1 } from 'common/icon/iconV1.js';
import { CompassDirection } from 'types/compass-direction.js';
import { isNotNullOrUndefined } from 'utilities/isType.js';

enum Direction {
  N = 'north',
  E = 'east',
  S = 'south',
  W = 'west',
  NE = 'northeast',
  SE = 'southeast',
  NW = 'northwest',
  SW = 'southwest',
}

const calculateStrength = (speed: number) => {
  // @TODO Ask for the actual numbers here
  if (speed < 15) {
    return 'light';
  }

  if (speed <= 29) {
    return 'moderate';
  }

  if (speed <= 39) {
    return 'fresh';
  }

  if (speed <= 62) {
    return 'strong';
  }

  /*
   * There should be one more but we have no icons but we have no _severe-gale_ icon
   * See issue https://alphero.sifterapp.com/issues/24058
   */
  if (speed > 62) {
    return 'gale';
  }

  // Fallback - just return fresh for now
  return 'n/a';
};

interface IProps {
  direction?: CompassDirection;
  speed?: number | string;
  className?: string;
}

export const WindChevron = ({ direction, speed, className }: IProps) => {
  if (isNotNullOrUndefined(speed) && isNotNullOrUndefined(direction)) {
    const actualSpeed = typeof speed === 'string' ? parseFloat(speed) : speed;

    // If speed is zero then return the rainfall-none icon
    if (actualSpeed === 0) {
      return <IconV1 icon="rainfall-none" iconClass={classNames('u-block', className)} />;
    }

    const iconName = `wind-${Direction[direction]}-${calculateStrength(actualSpeed)}` as IconNameV1;
    return <IconV1 icon={iconName} iconClass={className} />;
  }

  return null;
};
